import Vue from 'vue'
import Vuex from 'vuex'

import teacher from './modules/teacher'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    unRead: 0, // 未读个数
    refreshCourseDetail: {
      courseDetail: false,
      teachContent: false,
      classReport: false,
      reportCard: false
    }, // 是否需要刷新课程详情页，对应各个子页面
    courseDetailName: null,
    statisticsMap: new Map(), // 统计相关信息
    onlineActivitySelectedItemId: 0, // 线上活动详情选中项的id
    refreshOnlineWork: false ,// 线上活动作业
    selectedSemesterId: -1, // 课程列表选中的学期id
    toEmptyPage: false // 加载过空页面
  },
  mutations: {
    setUnReadNum (state, val) {
      state.unRead = val
    },
    reduceUnReadNum (state, val) {
      state.unRead -= val
    },
    // 保存课程的介绍信息和课程页面是否刷新的标记
    setCourseQueryParam (state, payload) {
      state.refreshCourseDetail = payload
    },
    // 重置课程的相关参数
    resetCourseDetailParam (state) {
      state.refreshCourseDetail.courseDetail = false
    },
    resetTeachContentParam (state) {
      state.refreshCourseDetail.teachContent = false
    },
    resetClassReportParam (state) {
      state.refreshCourseDetail.classReport = false
    },
    resetReportCardParam (state) {
      state.refreshCourseDetail.reportCard = false
    },
    setCourseDetailName (state, name) {
      state.courseDetailName = name
    },
    // 存储统计对象
    setStatistics (state, payload) {
      state.statisticsMap.set(payload.id, payload)
    },
    // 删除统计对象
    deleteStatistics (state, key) {
      state.statisticsMap.delete(key)
    },
    // 记录选中项的id
    saveOnlineActivitySelected (state, val) {
      state.onlineActivitySelectedItemId = val
    },
    // 设置是否刷新线上活动的作业
    setRefreshOnlineWork (state, val) {
      state.refreshOnlineWork = val
    },
    setSelectedSemesterId(state, val) {
      state.selectedSemesterId = val
    },
    setEmptyPage(state, val) {
      state.toEmptyPage = val
    }
  },
  getters: {
    getUnReadNum: function (state) {
      return state.unRead
    },
    getCourseIntro (state) {
      return state.courseIntro
    }
  },
  actions: {},
  modules: {
    teacher
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js